import React from 'react'
import Logo from '../images/logo.png'
import {Link} from 'react-router-dom'

function Navbars() {
  return (
   <>
   <div className="flex space-x-8 items-center pl-12 py-4">
      <img className='w-[30px] md:w-[50px]' src={Logo} alt={'logo'}/> 

      <Link  to="/" className="text-blue-500 font-bold text-xl md:text-3xl ">Movies</Link>
     
      <Link to="/Favourites" className="text-blue-500 font-bold text-xl md:text-3xl" >Favourites</Link>
   </div>  
   </>
  )
}

export default Navbars
